import oneLine from 'common-tags/lib/oneLine';

export function resolveScopedStyles(scope) {
  if (!scope.type || scope.type !== 'scope') {
    throw new TypeError(oneLine`
      Style resolver expexting <style jsx /> node to be wrapped
      in <scope> element.
    `);
  }

  return {
    className: scope.props.className,
    styles: () => scope.props.children,
    wrapClassNames: (...classNames) => [
      scope.props.className,
      ...classNames,
    ].filter(Boolean).join(' '),
  };
}
